import { createAction, props } from '@ngrx/store';
import { PathType } from '../../enums/path-type.enum';

export const updateType = createAction('[Path] Change Path Type', props<{ pathType: PathType }>());

export const init = createAction('[Init]');
